import { createFileRoute, Outlet, retainSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import classes from './dashboard.module.css';

export const Route = createFileRoute('/dashboard')({
  component: RouteComponent,
  validateSearch: zodValidator(
    z.object({
      startDate: z.string().nullable().optional(),
      endDate: z.string().nullable().optional(),
    }),
  ),
  search: {
    middlewares: [retainSearchParams(['startDate', 'endDate'])],
  },
});

function RouteComponent() {
  return (
    <div className={classes.main}>
      <Outlet />
    </div>
  );
}
